function thumbnailZoom() {
  if ($(window).width() >= 799) {
    $('.product__media-list')
      .find('.product__media img')
      .wrap('<span class="zoom-container"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        touch: false,
        magnify: 0.5,
      });
  }
}

export { thumbnailZoom as default };
